<template>
    <div>
        <el-date-picker
                v-model="date"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                value-format="timestamp"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="dateChange"/>

        <el-tabs class="common-el-tabs" v-model="activeName" type="card" @tab-click="$refs[activeName].getList()">
            <el-tab-pane label="玩家击中记录" name="Record">
                <comp-log-list ref="Record" class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane label="玩家贡献记录" name="UserIntoRecord">
                <comp-log-user-into ref="UserIntoRecord" class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane label="俱乐部贡献记录" name="ClubIntoRecord">
                <comp-log-club-into ref="ClubIntoRecord" class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane label="联盟贡献记录" name="TribeIntoRecord">
                <comp-log-tribe-into ref="TribeIntoRecord" class="common-el-tab-flex"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import {mapMutations, mapActions} from 'vuex'
    import compLogList from './compLogList'
    import compLogUserInto from './compLogUserInto'
    import compLogClubInto from './compLogClubInto'
    import compLogTribeInto from './compLogTribeInto'
    export default {
        components: {
            compLogList,
            compLogUserInto,
            compLogClubInto,
            compLogTribeInto
        },
        data() {
            return {
                date: '',
                activeName: 'Record',
            }
        },
        mounted() {
            this.setStateDate('');
            this.$refs[this.activeName].getList()
        },
        methods: {
            ...mapMutations('jackpot', ['setStateDate']),
            ...mapActions('jackpot', ['getRecord']),
            dateChange(e) {
                this.setStateDate(e);
                this.$refs[this.activeName].getList()
            }
        }
    }
</script>
<style lang="scss" scoped>
    :global(.el-date-editor) {
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 20px;
    }
</style>